import { render, staticRenderFns } from "./UniCard.vue?vue&type=template&id=700d24e9&scoped=true&"
import script from "./UniCard.vue?vue&type=script&lang=js&"
export * from "./UniCard.vue?vue&type=script&lang=js&"
import style0 from "./UniCard.vue?vue&type=style&index=0&id=700d24e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700d24e9",
  null
  
)

export default component.exports